import { useSearchParams } from 'react-router-dom';
import { ManageRegistrationMode, Spacing } from '../../types/appTypes';
import FullScreen from '../../components/Common/FullScreen/FullScreen';
import Container from '../../components/Common/Container/Container';
import Card from '../../components/Common/Card/Card';
import StatusText from '../../components/Common/StatusText/StatusText';
import ManageRegistrationForm from '../../components/Login/ManageRegistrationForm/ManageRegistrationForm';

type ManageRegistrationPageProps = {
  mode: ManageRegistrationMode;
};

const ManageRegistrationPage = ({ mode }: ManageRegistrationPageProps) => {
  const [searchParams] = useSearchParams();
  const dataId = searchParams.get('did') ?? searchParams.get('id') ?? undefined;
  const profileId = searchParams.get('pid') ?? undefined;

  const dataIdRequired = mode !== ManageRegistrationMode.Create;
  const profileIdRequired = mode === ManageRegistrationMode.EditApi;

  let display: React.ReactNode;
  if (dataIdRequired && (dataId === undefined || dataId === '')) {
    display = (
      <Card flexDirection='column'>
        <StatusText text='Invalid or missing data id.' error={true} />
      </Card>
    );
  } else if (
    profileIdRequired &&
    (profileId === undefined || profileId === '')
  ) {
    display = (
      <Card flexDirection='column'>
        <StatusText text='Invalid or missing profile id.' error={true} />
      </Card>
    );
  } else {
    display = (
      <ManageRegistrationForm
        mode={mode}
        dataId={dataId}
        profileId={profileId}
      />
    );
  }

  return (
    <FullScreen>
      <Container margin={[Spacing.Auto]}>{display}</Container>
    </FullScreen>
  );
};

export default ManageRegistrationPage;
